import {initializeInputs} from './inputs';
import {initializeDropdowns} from './dropdowns';
import {initializeAutoCompletes} from './autocompletes';
import _bundle from '../../../../core/core--bundles';

export default function () {
    _bundle.add({
        name: 'Initialize UI Elements', event: ['on:UiUpdate', 'on:PageUpdate'], fn() {
            initializeInputs();
            initializeDropdowns();
            initializeAutoCompletes();
        }
    });
    initializeInputs();
    initializeDropdowns();
    initializeAutoCompletes();
}
